import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/205a0d29-3db7-4460-b217-6453447b8263/images/931eec5d1df7992516ccd199eefa99032eb11e1d2dc58d70019cb8c3d8a4a539.png";

const Hero = () => {
  const { t, routes } = useI18n();

  return (
    <section className="relative bg-slate-950 text-white overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="" className="w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-28 pb-24 lg:pt-36 lg:pb-32">
        <div className="max-w-3xl">
          <p className="eyebrow text-slate-400 mb-5" data-testid="hero-eyebrow">{t.hero.eyebrow}</p>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="hero-h1">
            {t.hero.h1}
          </h1>
          <p className="mt-7 text-base sm:text-lg text-slate-300 max-w-2xl leading-relaxed">{t.hero.sub}</p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to={routes.quote} className="btn-primary" data-testid="hero-cta-primary">
              {t.hero.cta} <ArrowRight size={16} />
            </Link>
            <Link to={routes.contact} className="btn-ghost-light" data-testid="hero-cta-secondary">
              {t.hero.ctaSecondary}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
